import styled from 'styled-components'

import { Title as TitleUI, DescriptionText } from '../styles'

export const Wrapper = styled.section`
  margin-top: 85px;

  ${({ theme }) => theme.below.laptop`
    padding: 0 ${theme.spaces[3]}px;
  `}
`

export const Title = styled(TitleUI)`
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
`

export const Description = styled(DescriptionText)`
  margin-bottom: 50px;
`

export const ImageWrapper = styled.div`
  height: 125px;
  object-fit: cover;
  position: relative;
  width: 125px;
`

export const UserContainer = styled.div`
  background: linear-gradient(270deg, #d7fbe2 0%, #cdf0f6 100%);
  border-radius: 11px;

  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spaces[3]}px;
  justify-content: space-between;
  margin-bottom: 25px;
  padding: 22px 60px;

  &::last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.below.laptop`
    padding: 20px 40px 20px 18px;
  `}
`

export const UserDesctiptionBlock = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[1]}px;
  `}
`

export const UserBlockTitle = styled.h4`
  font-weight: 600;
  margin-bottom: 6px;
  text-transform: uppercase;
`

export const UserBlockInfo = styled.p`
  white-space: pre-wrap;
`
